import ResetPasswordSuccess from './ResetPasswordSuccess'
export default ResetPasswordSuccess